import { action, makeObservable, observable, override } from 'mobx'
import ModalViewModel from 'infra/ModalViewModel'

export interface UserInfoItemListProps {
  title: string
  userInfoItems: string[]
}

export default class UserInfoItemListViewModel extends ModalViewModel {
  /**
   * Title to use for the dialog.
   */
  @observable
  title = ''

  /**
   * List of user info items.
   */
  @observable
  userInfoItems: string[] = []

  constructor() {
    super()
    makeObservable(this)
  }

  /**
   * Sets the title.
   */
  @action.bound
  setTitle(title: string) {
    this.title = title
  }

  /**
   * Sets the user info items.
   */
  @action.bound
  setUserInfoItems(userInfoItems: string[]) {
    this.userInfoItems = userInfoItems
  }

  /**
   * Opens the dialog.
   */
  @action.bound
  showWith(props: UserInfoItemListProps) {
    this.setTitle(props.title)
    this.setUserInfoItems(props.userInfoItems)
    this.showing = true
  }

  /**
   * Closes the dialog.
   */
  @override
  close() {
    this.showing = false
    this.reset()
  }

  /**
   * Resets the dialog.
   */
  @action.bound
  reset() {
    this.title = ''
    this.userInfoItems = []
  }

  normalizeString(text: string) {
    return text.toLowerCase().replace(/\s+/g, '-')
  }
}
